import { useNode } from "@craftjs/core";
import Image from "next/legacy/image";
import * as React from "react";
import type { Vendor } from "src/types";

import PrimitivesFloatingOptions from "@/components/editor/block-outline/floating-options/primitives-floating-component";
import ImageBackdrop from "@/components/editor/shared/expo/booth-card/image-backdrop-component";
import BoothCardSettings from "@/components/editor/shared/expo/booth-card-settings/booth-card-settings-component";

import {
  Content,
  Description,
  Header,
  Heading,
  Logo,
  Wrapper,
} from "./booth-card-component-styles";

type BoothCardProps = {
  vendor: Vendor;
};

export default function BoothCard({ vendor }: BoothCardProps) {
  const {
    connectors: { connect },
  } = useNode();

  const backgroundImageSrc = React.useMemo(() => vendor.background_image, [
    vendor.background_image,
  ]);

  return (
    <Wrapper ref={connect}>
      <ImageBackdrop backgroundImageSrc={backgroundImageSrc}>
        <Image
          className="booth-banner-image"
          alt={`${vendor.name} banner`}
          src={backgroundImageSrc}
          layout="responsive"
          objectFit="contain"
          unoptimized
          width={392}
          height={195}
          draggable="false"
        />
      </ImageBackdrop>
      <Content>
        <Header>
          <Logo
            alt={`${vendor.name} logo`}
            src={vendor.image_url}
            draggable="false"
          />
          <Heading>{vendor.name}</Heading>
        </Header>
        <Description>{vendor.headline}</Description>
      </Content>
    </Wrapper>
  );
}

BoothCard.craft = {
  custom: {
    displayName: "Booth Card",
  },
  related: {
    leftOutlineOptions: PrimitivesFloatingOptions,
    settings: BoothCardSettings,
  },
};
